import React from 'react';

// Reusable Table Row Component
export const TableRow: React.FC<{
  children: React.ReactNode;
  className?: string;
  isDesktop?: boolean;
  id?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  onKeyDown?: React.KeyboardEventHandler<HTMLDivElement>;
  role?: string;
  tabIndex?: number;
  title?: string;
  'aria-label'?: string;
}> = ({ children, className = '', isDesktop = true, id, onClick, onKeyDown, role, tabIndex, title, 'aria-label': ariaLabel }) => {
  return (
    <div
      id={id}
      className={`invoice-table__desktop-row ${className}`}
      onClick={onClick}
      onKeyDown={onKeyDown}
      role={role}
      tabIndex={tabIndex}
      title={title}
      aria-label={ariaLabel}
    >
      {children}
    </div>
  );
};

// Reusable Table Cell Component
export const TableCell: React.FC<{
  children: React.ReactNode;
  className?: string;
  flex?: number;
}> = ({ children, className = '', flex = 1 }) => {
  return (
    <div className={`invoice-table__desktop-cell ${className}`} style={{ flex }}>
      {children}
    </div>
  );
};

// Reusable Table Header Component
export const TableHeader: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className = '' }) => {
  return (
    <div className={`invoice-table__header ${className}`}>
      {children}
    </div>
  );
};

// Reusable Table Column Header Component
export const TableColumn: React.FC<{
  children: React.ReactNode;
  className?: string;
  flex?: number;
}> = ({ children, className = '', flex = 1 }) => {
  return (
    <div className={`invoice-table__column ${className}`} style={{ flex }}>
      <span className="invoice-table__header-text">{children}</span>
    </div>
  );
};

// Reusable Mobile Card Row Component
export const MobileCardRow: React.FC<{
  label: string;
  children: React.ReactNode;
  className?: string;
}> = ({ label, children, className = '' }) => {
  return (
    <div className={`invoice-table__row ${className}`}>
      <div className="invoice-table__cell-label">
        <span className="invoice-table__cell-label-text">{label}</span>
      </div>
      <div className="invoice-table__cell-value">
        {children}
      </div>
    </div>
  );
};

// Reusable Mobile Card Wrapper Component
export const MobileCardWrapper: React.FC<{
  children: React.ReactNode;
  className?: string;
  id?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  onKeyDown?: React.KeyboardEventHandler<HTMLDivElement>;
  role?: string;
  tabIndex?: number;
  title?: string;
  'aria-label'?: string;
}> = ({ children, className = '', id, onClick, onKeyDown, role, tabIndex, title, 'aria-label': ariaLabel }) => {
  return (
    <div
      id={id}
      className={`invoice-table__row-wrapper ${className}`}
      onClick={onClick}
      onKeyDown={onKeyDown}
      role={role}
      tabIndex={tabIndex}
      title={title}
      aria-label={ariaLabel}
    >
      {children}
    </div>
  );
};

// Reusable Table Body Component
export const TableBody: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className = '' }) => {
  return (
    <div className={`invoice-table__body ${className}`}>
      {children}
    </div>
  );
};

// Reusable Table Container Component
export const TableContainer: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className = '' }) => {
  return (
    <div className={`invoice-table ${className}`}>
      {children}
    </div>
  );
};
